// extracted by mini-css-extract-plugin
module.exports = {"container":"privacyToggle_container__1pA85","text":"privacyToggle_text__1OLPW","toggleContainer":"privacyToggle_toggleContainer__39db7","toggle":"privacyToggle_toggle__7Q9ap"};